import { BookingNewContext } from '../../bookingNewContext'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { EntityDefaultValueUtil } from '@/class/cargo/model/utils/EntityDefaultValueUtil'
import { getUserDefaultDepartment } from '@/api/user'

/**
 * BookingWorkspace的Context
 */
export class BookingWorkspaceContext extends BookingNewContext {
  /**
   * constructor
   */
  constructor(obj) {
    super(obj)
    if (!(obj instanceof BookingWorkspaceContext)) {
      this._data.defaultSeaExportJob = null
      this._data.defaultLclSeaExportJob = null
      this._data.opDepartment = null
      this._data.modifiedData = {} // 在页面中看不到，但被联动修改了的实体数据
      this._data._activeCmpList = [] // 活跃或正在使用中的合作伙伴列表
      this._data.reloadCharge = false // 重新加载费用标识
      this._data.reloadChargeAr = false // 重新加载费用标识(应收)
      this._data.reloadChargeAp = false // 重新加载费用标识(应付)
    }
  }
  get userList() {
    return getCacheListByKey(basicCacheKeys.basic_data_User)
  }
  set userList(userList) {
    // 不可赋值
  }
  get companyList() {
    return getCacheListByKey(basicCacheKeys.basic_data_Company)
  }
  set companyList(companyList) {
    // 不可赋值
  }
  get seaPortList() {
    return getCacheListByKey(basicCacheKeys.basic_data_Seaport)
  }
  set seaPortList(seaPortList) {
    // 不可赋值
  }
  get regionList() {
    return getCacheListByKey(basicCacheKeys.basic_data_Region)
  }
  set regionList(regionList) {
    // 不可赋值
  }
  get paymentTermList() {
    return getCacheListByKey(basicCacheKeys.basic_data_PaymentTerm)
  }
  set paymentTermList(paymentTermList) {
    // 不可赋值
  }
  get packingList() {
    return getCacheListByKey(basicCacheKeys.basic_data_Packing)
  }
  set packingList(packingList) {
    // 不可赋值
  }
  get shippingTermList() {
    return getCacheListByKey(basicCacheKeys.basic_data_ShippingTerm)
  }
  set shippingTermList(shippingTermList) {
    // 不可赋值
  }
  get blModeList() {
    return getCacheListByKey(basicCacheKeys.basic_data_BlMode)
  }
  set blModeList(blModeList) {
    // 不可赋值
  }
  get defaultSeaExportJob() {
    return this._data.defaultSeaExportJob
  }
  set defaultSeaExportJob(defaultSeaExportJob) {
    this._data.defaultSeaExportJob = defaultSeaExportJob
  }
  get defaultLclSeaExportJob() {
    return this._data.defaultLclSeaExportJob
  }
  set defaultLclSeaExportJob(defaultLclSeaExportJob) {
    this._data.defaultLclSeaExportJob = defaultLclSeaExportJob
  }
  get opDepartment() {
    return this._data.opDepartment
  }
  set opDepartment(opDepartment) {
    this._data.opDepartment = opDepartment || 0
  }
  get modifiedData() {
    return this._data.modifiedData
  }
  set modifiedData(modifiedData) {
    this._data.modifiedData = modifiedData
  }
  get reloadCharge() {
    return this._data.reloadCharge
  }
  set reloadCharge(reloadCharge) {
    this._data.reloadCharge = reloadCharge
  }
  get reloadChargeAr() {
    return this._data.reloadChargeAr
  }
  set reloadChargeAr(reloadChargeAr) {
    this._data.reloadChargeAr = reloadChargeAr
  }
  get reloadChargeAp() {
    return this._data.reloadChargeAp
  }
  set reloadChargeAp(reloadChargeAp) {
    this._data.reloadChargeAp = reloadChargeAp
  }
  /**
   * 获取实例
   */
  static getInstance() {
    if (!this._instance) {
      this._instance = new BookingWorkspaceContext(super.getInstance())
    }
    return this._instance
  }
  /**
   * 准备好数据
   */
  async prepareData() {
    await super.prepareData()
  }
  getCompanyById(cmpIdx) {
    if (!this.companyList) {
      return null
    }
    const activeCmpList = this._data._activeCmpList
    let cmp = activeCmpList.find(p => p.cmpIdx === cmpIdx)
    if (!cmp) {
      cmp = this.companyList.find(p => p.cmpIdx === cmpIdx)
      if (cmp) {
        activeCmpList.push(cmp)
      }
    }
    return cmp
  }
  async getDefaultSeaExportJob() {
    const entityDefValUtil = EntityDefaultValueUtil.getInstance()
    if (!entityDefValUtil.defaultValues) {
      await entityDefValUtil.initEntityDefaultValue()
    }
    this.defaultSeaExportJob = entityDefValUtil.seaExportJob.getData()
  }
  /**
   * 用于小票
   */
  async getDefaultLclSeaExportJob() {
    const entityDefValUtil = EntityDefaultValueUtil.getInstance()
    if (!entityDefValUtil.defaultValues) {
      await entityDefValUtil.initEntityDefaultValue()
    }
    const fieldList = ['freightTermHBL', 'paymentTermHBL', 'paymentPlaceBL', 'incoTerm', 'packing']
    this.defaultLclSeaExportJob = {}
    if (entityDefValUtil.seaExportJob && entityDefValUtil.seaExportJob.getData()) {
      const seJob = entityDefValUtil.seaExportJob.getData()
      Object.keys(seJob).forEach(key => {
        if (fieldList.includes(key)) {
          this.defaultLclSeaExportJob[key] = seJob[key]
        }
      })
    }
  }
  async getOpDepartment(office) {
    if (!this.opDepartment || Number(this.opDepartment.departmentId) <= 0) {
      this.opDepartment = await getUserDefaultDepartment({ category: 'role', shape: 'op', userId: 0, officeId: office.officeId }).then(res => res.data)
    }
  }
}
